module.exports = __webpack_public_path__ + "static/media/picto-edit.a1f333d8.svg";